<template>
  <v-layout row justify-center>
    <v-dialog v-model="deleteTemplateDialog" max-width="450">
      <v-card>
        <v-card-title class="headline red--text">Delete Template?</v-card-title>

        <v-card-text>
          <v-alert
            text
            prominent
            type="error"
            icon="error"
          >Are you sure you want to delete this equipment template</v-alert>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="blue darken-1" text @click="deleteTemplateDialog = false">Cancel</v-btn>

          <v-btn color="red darken-1" text @click="onDeleteAssetTemplate()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn class="mt-3 mb-3 mr-5" fab small color="black" v-on="on">
          <v-icon dark>settings</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <br />
        <v-card class="mx-auto" flat max-width="900">
          <p class="pt-5 body-2 grey--text">Equipment Template</p>

          <v-data-table
            :headers="assetTemplateHeader"
            :items="assetTemplate"
            class="elevation-1"
            :sort-by="['Description']"
          >
            <template v-slot:item.delete="{ item }">
              <v-btn color="error" dark x-small right fab @click="deleteAssetTemplate(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <v-card-text style="height: 100px; position: relative">
            <v-fab-transition>
              <v-btn
                color="blue darken-2"
                dark
                absolute
                top
                right
                fab
                @click="assetTemplateDialog = !assetTemplateDialog"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-fab-transition>
          </v-card-text>

          <v-dialog v-model="assetTemplateDialog" max-width="500px">
            <v-card>
              <v-card-title class="grey--text">Equipment Template</v-card-title>
              <v-divider></v-divider>
              <br />
              <v-card-text>
                <v-form ref="form">
                  <v-text-field
                    v-model="description"
                    :rules="[rules.required]"
                    label="Description"
                    required
                  ></v-text-field>
                  <v-text-field v-model="model" :rules="[rules.required]" label="Model" required></v-text-field>
                  <v-select
                    v-model="maintenance"
                    :items="maintenanceList"
                    :rules="[rules.required]"
                    label="Maintenance frequency"
                  ></v-select>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="onCreateAssetTemplate">Submit</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import * as mutations from "./../graphql/mutations";
// import * as queries from "./../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";

export default {
  created() {
    const query = `query ListEquipmentLogAssetTemplates {
            listEquipmentLogAssetTemplates (limit: 100) {
                items {
                    id,
                    category,
                    model,
                    maintenance,
                }
            }
        }`;
    API.graphql(graphqlOperation(query)).then(result => {
      this.assetTemplate = result.data.listEquipmentLogAssetTemplates.items;
      this.assetTemplate = _.orderBy(this.assetTemplate, "category", "asc")
    });
  },
  data() {
    return {
      dialog: false,
      assetTemplateDialog: false,
      deleteTemplateDialog: false,
      description: "",
      model: "",
      maintenance: "",
      maintenanceList: ["N/A", "Daily", "Weekly", "Monthly", "Yearly"],
      templateAssetId: "",
      assetTemplateHeader: [
        { text: "Description", value: "category" },
        { text: "Model", value: "model" },
        { text: "Frequency", value: "maintenance" },
        { align: "right", sortable: false, value: "delete" }
      ],
      assetTemplate: [],
      rules: {
        required: v => !!v || "This field is required."
      }
    };
  },
  methods: {
    onCreateAssetTemplate() {
      if (this.$refs.form.validate()) {
        const query = `mutation CreateEquipmentLogAssetTemplates (
                    $category: String!
                    $model: String!
                    $maintenance: String!
                    ) {
                    createEquipmentLogAssetTemplate(input: {
                        category: $category,
                        model: $model,
                        maintenance: $maintenance,
                    }){
                        id,
                        category,
                        model,
                        maintenance
                    }
                }`;

        API.graphql(
          graphqlOperation(query, {
            category: this.description,
            model: this.model,
            maintenance: this.maintenance
          })
        ).then(result => {
          let asset = result.data.createEquipmentLogAssetTemplate;
          this.assetTemplate.push(asset);
          this.assetTemplateDialog = false;
          this.description = "";
          this.model = "";
          this.maintenance = "";
          this.$root.$emit("addToAssetTemplate", asset); // Pass parms to EquipmentLog.vue
        });
      }
    },
    onDeleteAssetTemplate() {
      const query = `mutation DeleteEquipmentLogAssetTemplate($id: ID!) {
                deleteEquipmentLogAssetTemplate (input: {
                    id: $id
                }){
                    id
                }
            }`;

      API.graphql(
        graphqlOperation(query, {
          id: this.templateAssetId
        })
      ).then(result => {
        this.deleteTemplateDialog = !this.deleteTemplateDialog;
        this.assetTemplate = this.assetTemplate.filter(function(obj) {
          return obj.id !== result.data.deleteEquipmentLogAssetTemplate.id;
        });
        this.$root.$emit(
          "deleteFromAssetTemplate",
          result.data.deleteEquipmentLogAssetTemplate.id
        );
      });
    },
    deleteAssetTemplate(id) {
      this.templateAssetId = id;
      this.deleteTemplateDialog = !this.deleteTemplateDialog;
    }
  }
};
</script>
